import React from 'react';
import { createRoot } from 'react-dom/client';
/**
 * Converts an icon element to an HTML image element with a specified color.
 * @param icon - The icon element to convert.
 * @param color - The color to apply to the icon.
 * @param size - The size of the icon.
 * @returns A promise that resolves to the converted HTML image element.
 */
export const iconConverter = ({ icon, color, size }) => {
    return new Promise((resolve) => {
        const markerContainer = document.createElement('div');
        const iconWithStyle = React.cloneElement(icon, { style: { fill: color, ...icon.props.style } });
        const root = createRoot(markerContainer);
        const observer = new MutationObserver(() => {
            if (markerContainer.innerHTML) {
                const svgData = markerContainer.innerHTML;
                const path = `data:image/svg+xml;charset=utf-8;base64,${btoa(svgData)}`;
                const image = new Image(size, size);
                image.onload = () => {
                    resolve(image);
                    observer.disconnect();
                };
                image.src = path;
            }
        });
        observer.observe(markerContainer, { childList: true });
        root.render(iconWithStyle);
    });
};
//# sourceMappingURL=iconConverter.js.map